import actions from './actions'

const initialState = {
  subscriptions: {},
  postViews: {},
  postLikes: {},
  postBookmarks: {},
  postComments: {},
  lastMonthStats: {},
  revenue: {},
  loading: false,
  detail: {},
}

export default function analyticsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
